export default __webpack_public_path__ + "static/media/index-funds.2e7bafa1.gif";